import { useMemo } from 'react';
import { useBroadcastStore } from 'entities/broadcast';
import { useGetEvents } from 'entities/event';

export const useEvents = () => {
  const broadcastList = useBroadcastStore(state => state.list);

  const eventIds = useMemo(() => {
    return broadcastList.reduce((acc, cur) => {
      cur.mappings
        ?.map(el => el.sbSportEventId)
        .forEach(el => {
          !acc.includes(el) && acc.push(el);
        });
      return acc;
    }, [] as number[]);
  }, [broadcastList]);

  useGetEvents(eventIds);
};
